import { Search, Filter } from 'lucide-react'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

interface AttributesFiltersProps {
  searchInput: string
  onSearchChange: (value: string) => void
  categoryFilter: string | 'all'
  onCategoryFilterChange: (value: string | 'all') => void
  subcategoryFilter: string | 'all'
  onSubcategoryFilterChange: (value: string | 'all') => void
  categoryOptions: string[]
  subcategoryOptions: string[]
}

export function AttributesFilters({
  searchInput,
  onSearchChange,
  categoryFilter,
  onCategoryFilterChange,
  subcategoryFilter,
  onSubcategoryFilterChange,
  categoryOptions,
  subcategoryOptions,
}: AttributesFiltersProps) {
  return (
    <div className="flex items-center gap-3 rounded-lg border border-border bg-card p-3">
      {/* Search Input */}
      <div className="relative flex-1 max-w-88">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Search attributes..."
          value={searchInput}
          onChange={e => onSearchChange(e.target.value)}
          className="pl-9 bg-muted/50"
        />
      </div>

      {/* Filter Icon */}
      <Filter className="h-6 w-6 text-muted-foreground" />

      {/* Category Filter */}
      <Select value={categoryFilter} onValueChange={onCategoryFilterChange}>
        <SelectTrigger className="w-42.5">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Categories</SelectItem>
          {categoryOptions.map(option => (
            <SelectItem key={option} value={option}>
              {option}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {/* Subcategory Filter */}
      <Select
        value={subcategoryFilter}
        onValueChange={onSubcategoryFilterChange}
      >
        <SelectTrigger className="w-47.5">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Subcategories</SelectItem>
          {subcategoryOptions.map(option => (
            <SelectItem key={option} value={option}>
              {option}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
